<template>
  <div>
    <main>
      <div class="relative">
        <div class="relative w-full h-[500px] bg-center bg-cover bg-no-repeat" :style="'background-image: url(' + config.projectURL + 'assets/images/events/' + eventDetails.image + '.jpg);'">
          <div class="absolute inset-0" style="background-image: linear-gradient(to bottom, rgba(14, 29, 46, 0.6), rgba(14, 29, 46, 1));">
            <!-- Ihr Inhalt hier -->
          </div>
        </div>
        <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4/5 md:w-auto">
  <!--        <h3 class="text-center text-4xl text-[#E3000B] font-bold">Nachtschicht Kaiserslautern - Lounges</h3>-->
        </div>
        <div class="px-6 md:max-w-screen-xl md:m-auto mt-12 md:mt-24">
          <div class="text-center">
            <h6 class="text-[#E3000B] text-2xl md:text-3xl font-semibold">{{ startDate }}</h6>
            <h2 class="text-3xl md:text-5xl font-semibold pt-4">{{ eventDetails.title}}</h2>
          </div>
          <div class="grid grid-cols-2 gap-4 mt-6 md:mt-12 md:grid-cols-4">
            <div class="bg-gray-950 rounded-lg text-center py-6 px-2 md:py-10">
              <div class="flex justify-center">
                <img src="/assets/images/icons/CalendarDays.svg" class="w-[44px] mb-1">
              </div>
              <h5 class="font-semibold text-lg md:text-xl py-4">{{ startDate }}</h5>
              <h6 class="text-gray-600 ">{{ startDay }}</h6>
            </div>
            <div class="bg-gray-950 rounded-lg text-center py-6 px-2 md:py-10">
              <div class="flex justify-center">
                <img src="/assets/images/icons/Clock.svg" class="w-[44px] mb-1">
              </div>
              <h5 class="font-semibold text-lg md:text-xl py-4">{{ startTime }} Uhr</h5>
              <h6 class="text-gray-600 ">Beginn</h6>
            </div>
            <div class="bg-gray-950 rounded-lg text-center py-6 px-2 md:py-10">
              <div class="flex justify-center">
                <img src="/assets/images/icons/Identification.svg" class="w-[44px] mb-1">
              </div>
              <h5 class="font-semibold text-lg md:text-xl py-4">{{eventDetails.muttizettel?'':'nicht '}}verfügbar</h5>
              <h6 class="text-gray-600 ">Muttizettel</h6>
            </div>
            <div class="bg-gray-950 rounded-lg text-center py-6 px-2 md:py-10">
              <div class="flex justify-center">
                <img src="/assets/images/icons/Banknotes.svg" class="w-[44px] mb-1">
              </div>
              <h5 class="font-semibold text-lg md:text-xl py-4">{{ cheapestPrice ? cheapestPrice+'€' : eventDetails.abendkassePrice ? eventDetails.abendkassePrice+'€' : 'Keine Angabe' }} </h5>
              <h6 class="text-gray-600 ">Eintritt</h6>
            </div>
            <div class="col-span-2 md:col-span-4 bg-gray-950 rounded-lg text-center py-4 px-2">
              <div class="flex justify-center">
                <div class="mb-1">
                  <svg width="50px" viewBox="0 0 91 91" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 91 91"><path d="M66.9 41.8c0-11.3-9.1-20.4-20.4-20.4-11.3 0-20.4 9.1-20.4 20.4 0 11.3 20.4 32.4 20.4 32.4s20.4-21.1 20.4-32.4zM37 41.4c0-5.2 4.3-9.5 9.5-9.5s9.5 4.2 9.5 9.5c0 5.2-4.2 9.5-9.5 9.5-5.2 0-9.5-4.3-9.5-9.5z" fill="#7f07e4" class="fill-000000" /></svg>
                </div>
                <h5 class="text-lg py-4">{{ eventDetails.location }} </h5>
              </div>
            </div>
          </div>
          <div class="p-2"></div>
          <div v-if="eventDetails.muttizettel" class="bg-gray-950 rounded-lg text-center px-4 py-8">
            <h4 class="text-left md:text-center text-xl md:text-2xl">Dein Clubzettel für eine unvergessliche Nacht. 🎉</h4>
            <p class="text-left md:text-center pt-2">Sie sagten, feiern kannst du auch noch später? Nicht mit uns! Deine Zeit ist jetzt - und die guten Partys am Wochenende!</p>
            <div class="cursor-pointer">
              <router-link to="/muttizettel">
                <button class="m-auto bg-primary p-4 rounded-lg text-left grid grid-cols-8 items-center mt-6" @click="page = 'new'">
                  <div class="col-span-2">
                    <svg width="48px" fill="none" viewBox="0 0 142 175" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" fill="#ffffff" class="fill-000000"><path d="M140.752 92.915c.179 16.504.42 33.008.506 49.513.031 5.833-.427 11.667-.459 17.502-.046 8.37-6.514 13.468-14.13 13.632-15.602.338-31.21.699-46.812.621-18.078-.09-36.157-.566-54.23-1.044a102.916 102.916 0 0 1-13.046-1.416c-4.962-.773-9.834-6.703-10.099-12.102-.262-5.378-.475-10.76-.545-16.142a28666.69 28666.69 0 0 1-.878-75.128C.9 53.64.837 38.928.612 24.218c-.066-4.17-.367-8.353 1.32-12.268A25.62 25.62 0 0 1 5.58 5.597c1.864-2.22 4.614-3.061 7.554-3.142 6.06-.166 12.13-.205 18.176-.605 21.335-1.41 42.666-.308 64-.15 4.538.034 7.988 1.517 11.335 4.698 6.832 6.492 14.164 12.456 21.248 18.685 2.697 2.371 5.199 4.967 7.936 7.286 2.525 2.14 3.505 4.833 3.6 8.003.167 5.611.433 11.22.512 16.832.166 11.904.239 23.809.351 35.713l.461-.002ZM93.45 10.102c-1.939-.158-3.595-.387-5.254-.416-14.145-.239-28.29-.456-42.434-.652-6.394-.089-12.79-.124-19.184-.163-3.25-.02-6.505-.123-9.746.042-4.635.236-5.997 1.58-6.826 6.27a43.112 43.112 0 0 0-.483 12.733c.22 1.782.336 3.576.346 5.372.074 40.08.137 80.159.187 120.236-.04 1.01-.003 2.021.111 3.024.806 5.12 3.505 8.229 9.09 8.455 21.664.874 43.329.869 65 .504 11.001-.185 22.004-.275 33.006-.401 2.691-.031 5.389.076 8.073-.065 4.419-.239 6.755-2.662 6.705-7.103-.053-4.932-.418-9.862-.501-14.794-.096-5.724.098-11.454-.066-17.175-.403-14.249-1.098-28.49-1.37-42.74-.223-11.672 0-23.35.01-35.027 0-.941-.114-1.883-.155-2.503-3.898 0-7.373-.013-10.849.004-3.593.017-7.189.153-10.778.066a30.125 30.125 0 0 1-6.33-.722c-4.248-1.033-5.552-2.663-6.047-6.969-.14-1.225-.147-2.465-.262-3.694-.723-7.931-1.462-15.858-2.243-24.282Zm12.103 27.544 19.362-1.193.295-.652c-7.662-6.52-14.864-13.55-22.939-19.795 1.073 7.068 2.144 14.137 3.282 21.64Z"></path><path d="m64.558 110.884 19.444-18.51a16.82 16.82 0 0 0-2.177-.247c-14.813.544-29.628 1.075-44.439 1.692-3.36.14-6.705.644-10.064.868a18.084 18.084 0 0 1-3.989-.244 2.12 2.12 0 0 1-1.478-.765 2.11 2.11 0 0 1-.465-1.598 4.498 4.498 0 0 1 1.335-2.827 6.973 6.973 0 0 1 3.462-1.09c10.505-.94 21.003-2.002 31.53-2.625 9.411-.556 18.853-.61 28.282-.861 2.015-.054 4.033-.008 6.498-.008 3.18-3.15 6.585-6.564 10.042-9.924 2.257-2.197 3.648-2.475 5.996-1.151a7.253 7.253 0 0 1 1.934 1.822c2.32 2.887 4.595 5.808 6.877 8.729 2.741 3.51 2.363 5.895-1.008 8.972-6.202 5.662-12.29 11.447-19.014 17.732 5.528-.204 10.154-.384 14.781-.537a15.588 15.588 0 0 1 2.68.099 2.806 2.806 0 0 1 2.582 2.674c.174 1.501-.413 2.848-1.82 3.255-1.932.558-3.924.88-5.933.956-6.276.23-12.56.296-19.224.432-4.138 4.382-8.305 8.907-12.622 13.283a10.977 10.977 0 0 1-3.944 2.413c-3.362 1.247-6.94 1.963-10.203 3.41-5.227 2.319-10.662 2.197-16.156 2.254-6.4.066-12.799.376-19.196.514-1.346.04-2.69-.09-4.004-.386a2.702 2.702 0 0 1-2.278-2.917 2.853 2.853 0 0 1 2.444-2.822 17.863 17.863 0 0 1 3.348-.225c9.429-.238 18.858-.455 28.288-.704.876-.023 1.748-.218 2.761-.351 1.12-4.599 1.116-9.152 1.09-14.193h-3.742c-9.324.018-18.647.066-27.97.027a16.45 16.45 0 0 1-4.266-.677 2.452 2.452 0 0 1-1.813-2.861 2.33 2.33 0 0 1 .696-1.503c.409-.398.95-.63 1.519-.656a39.845 39.845 0 0 1 4.67-.591c9.2-.322 18.402-.605 27.605-.848 2.68-.074 5.37-.011 7.94-.011Zm30.705-21.637c-9.606 9.195-19.512 17.499-28.63 26.902l10.116 8.073c8.574-8.853 16.943-17.495 25.359-26.188l-6.845-8.787Zm5.42-3.83 7.323 6.856 4.362-4.092-6.425-9.132-5.26 6.368Zm-36.36 34.998c.077 3.376-.601 6.144.176 8.912 3.795-.577 4.988-1.017 6.845-2.53l-7.022-6.382ZM69.995 70.03c-9.534.46-19.064.99-28.6 1.362-5.16.201-10.332.14-15.498.182a6.675 6.675 0 0 1-1.67-.17 2.668 2.668 0 0 1-2.218-2.606 2.725 2.725 0 0 1 2.363-2.83 12.905 12.905 0 0 1 2.01-.155c13.221-.807 26.44-1.665 39.665-2.398 7.399-.409 14.81-.59 22.214-.912 7.292-.319 14.58-.71 21.871-1.018a41.228 41.228 0 0 1 6.381.049c2.391.272 3.522 1.556 3.501 3.365-.021 1.844-1.141 2.954-3.564 3.255-2.339.292-4.695.51-7.05.596-13.131.481-26.263.937-39.397 1.367l-.008-.086Z"></path></g><defs><clipPath id="a"><path fill="#ffffff" transform="translate(.408 .574)" d="M0 0h141.113v173.93H0z" class="fill-ffffff"></path></clipPath></defs></svg>
                  </div>
                  <div class="col-span-6">
                    <span style="display: block; font-size: 1.4em; margin-top: 8px;">Neuen Muttizettel erstellen</span>
                  </div>
                </button>
              </router-link>
            </div>
          </div>
          <h4 class="text-2xl text-center pt-6 md:pt-12 md:text-3xl">Eventdetails</h4>
          <div class="p-2"></div>
          <div class="bg-gray-950 rounded-lg text-center px-6 py-8">
            <p class="text-left" v-html="nl2br(eventDetails.description)"></p>
          </div>
          <div class="p-4"></div>
          <section class="bg-gray-950 br-10 md:max-w-screen-sm md:m-auto" id="ticketSale" v-if="parseInt(eventDetails.ticketSale) === 1">
            <div class="pad-16" ref="tickets">
              <h4 class="f-bold color-white t-center">
                Jetzt Tickets sichern!
              </h4>
              <div>
                <div class="grid-12" v-if="eventDetails.ticketSaleLink != null && eventDetails.ticketSaleLink !== 'null'">
                  <div class="col-sp-6 row-sp-12">
                    <p>Tickets über externen Anbieter kaufen:</p>
                  </div>
                  <div class="col-sp-6 row-sp-12 t-right">
                    <a :href="eventDetails.ticketSaleLink" target="_blank" class="button bg-[#E3000B] color-white">Ticket Shop öffnen</a>
                  </div>
                </div>
                <div v-else>
                  <ticketItems v-for="titems in ticketItems" :ticket-items="titems" :key="titems.id" />
                  <p v-if="!ticketItems.length" class="t-center">
                    Aktuell sind keine Tickets verfügbar
                  </p>
                </div>
              </div>
            </div>
          </section>
          <div class="pad-32" />
          <section class="br-10" id="ticketSale" v-if="lounges != ''">
            <div class="">
              <h4 class="f-bold color-white t-center pt-6">
                Jetzt Lounges sichern!
              </h4>
              <div>
                <div>
                  <lounge v-for="lounge in lounges" :lounge="lounge" :key="lounge.id" />
                </div>
              </div>
            </div>
          </section>
          <section id="otherEvents">
            <div>
              <h4 class="t-center">
                Weitere <span class="text-primary">Events</span>
                die dir gefallen könnten
              </h4>
            </div>
            <section id="searchResults">
              <div class="md:grid grid-cols-3 gap-x-4">
                <events v-for="event in events" :event="event" :key="event.id" />
              </div>
              <p class="t-center color-white" v-if="events.length == 0">
                Aktuell gibt es keine weiteren geplanten Events.
              </p>
            </section>
          </section>
        </div>
      </div>
    </main>
<!--    <main class="content-500">-->
<!--      <section id="eventDetailsHeader">-->
<!--        <div class="t-right">-->
<!--          <div class="label button bgcolor-blue color-white">-->
<!--            {{ eventDetails.categories }}-->
<!--          </div>-->
<!--        </div>-->
<!--        <img class="titleImage" :src="config.projectURL + 'assets/images/events/'+eventDetails.image+'.jpg'">-->
<!--        <div class="t-left">-->
<!--          <h3 style="font-size: 1.6em; padding: 16px 16px 16px 0">-->
<!--            {{ eventDetails.title }}-->
<!--          </h3>-->
<!--&lt;!&ndash;          <h4 class="f-bold color-blue">&ndash;&gt;-->
<!--&lt;!&ndash;            {{ eventDetails.subTitle }}&ndash;&gt;-->
<!--&lt;!&ndash;          </h4>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="detailswrapper grid-12 t-center">-->
<!--          <div class="col-sp-4 row-sp-12 detailbox ">-->
<!--            <h4>{{ startDate }}</h4>-->
<!--            <h5>{{ startDay }}</h5>-->
<!--          </div>-->
<!--          <div class="col-sp-4 row-sp-12 detailbox ">-->
<!--            <h4>{{ startTime }} Uhr</h4>-->
<!--            <h5>Beginn</h5>-->
<!--          </div>-->
<!--          <div class="col-sp-4 row-sp-12 detailbox ">-->
<!--            <h4>{{ cheapestPrice }} €</h4>-->
<!--            <h5>VVK: {{ vvkEnd }} Uhr</h5>-->
<!--          </div>-->
<!--          <div class="col-sp-12 row-sp-12">-->
<!--            <a target="_blank" :href="'https://www.google.com/maps?q='+eventDetails.location" class="col-sp-12 row-sp-12 detailboxFlex">-->
<!--              <svg width="50px" viewBox="0 0 91 91" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 91 91"><path d="M66.9 41.8c0-11.3-9.1-20.4-20.4-20.4-11.3 0-20.4 9.1-20.4 20.4 0 11.3 20.4 32.4 20.4 32.4s20.4-21.1 20.4-32.4zM37 41.4c0-5.2 4.3-9.5 9.5-9.5s9.5 4.2 9.5 9.5c0 5.2-4.2 9.5-9.5 9.5-5.2 0-9.5-4.3-9.5-9.5z" fill="#ffffff" class="fill-000000" /></svg>-->
<!--              <p class="color-white">-->
<!--                {{ eventDetails.location }}-->
<!--              </p>-->
<!--            </a>-->
<!--          </div>-->
<!--          <div class="col-sp-12 row-sp-12 clubzettel">-->
<!--            <div class="grid-12">-->
<!--              <div class="col-sp-6 row-sp-12 box">-->
<!--                <div class="flex">-->

<!--                  <div v-if="eventDetails.muttizettel" class="accept">-->
<!--                    <span>👍🏼</span>-->
<!--                  </div>-->
<!--                  <div v-else class="reject">-->
<!--                    <span>👎🏼</span>-->
<!--                  </div>-->

<!--                  <span>Muttizettel</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-sp-6 row-sp-12 box">-->
<!--                <div class="flex">-->
<!--                  <div v-if="eventDetails.abendkasse" class="accept" >-->
<!--                    <span>👍🏼</span>-->
<!--                  </div>-->
<!--                  <div v-else class="reject">-->
<!--                    <span>👎🏼</span>-->
<!--                  </div>-->
<!--                  <span>Abendkasse</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-sp-12 row-sp-12 ticketButton">-->
<!--            <a @click="scrollToTickets()">Jetzt Ticket sichern</a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </section>-->
<!--      <section id="eventDetailsContent">-->
<!--        <div style="text-transform: uppercase; font-size: 1.4em; padding-left: 16px;">-->
<!--          <h3>Event Details</h3>-->
<!--        </div>-->
<!--        <div class="pad-16 color-white br-10 eventDetailsBox">-->
<!--          <p v-html="nl2br(eventDetails.description)" />-->
<!--        </div>-->
<!--        <div class="pad-16 t-center" id="eventLabels">-->
<!--          <eventLabels v-for="elitems in eventLabels" :event-labels="elitems" :key="elitems.id" />-->
<!--        </div>-->
<!--      </section>-->
<!--      <section id="joinCTA">-->
<!--        <div class="pad-16 t-center">-->
<!--          <h5 class="color-white f-bold">-->
<!--            {{ isAttendees ? 'Du nimmst teil!' : 'Bereit für eine verrückte Nacht ?' }}-->
<!--          </h5>-->
<!--          <button v-if="!isAttendees" class="button bgcolor-blue color-white" @click="attendee()">-->
<!--            Jetzt Teilnehmen-->
<!--          </button>-->
<!--          <button v-else class="button bgcolor-second color-white" @click="attendee()">-->
<!--            Absagen-->
<!--          </button>-->
<!--          <button class="button bgcolor-second color-white sharebutton" @click="openShareMenu()" v-if="shareMenu">-->
<!--            <img src="assets/images/icons/share-white.svg" class="width-20">-->
<!--          </button>-->
<!--        </div>-->
<!--      </section>-->
<!--      <section v-if="eventDetails.muttizettel" class="bgcolor-second br-10 pad-24" style="margin-bottom: 16px;">-->
<!--        <h4 class="f-bold color-white t-center f-normal" style="font-size: 1.3em;">-->
<!--          Noch keine 18? Kein Problem:-->
<!--        </h4>-->
<!--        <div class="pad-4"></div>-->
<!--        <router-link :to="'/muttizettel?event='+eventDetails.id" class="button bgcolor-blue fluid color-white t-center" style="box-sizing: border-box;">-->
<!--          Muttizettel ausfüllen-->
<!--        </router-link>-->
<!--      </section>-->
<!--
    </main>-->
    <transition name="modal" id="filterModal">
      <div class="vueModal" v-if="filterModal">
        <div class="vueModalOuter" @click="filterModal = false;" />
        <div class="vueModalInner bottom bgcolor-second">
          <div class="t-center pad-8">
            <h2>Events Filtern</h2>
            <button @click="filterModal = false;" class="button fluid bgcolor-blue color-white">
              Okay
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {authStore} from "@/store/authStore";
import {configStore} from "@/store/configStore";
import {userStore} from "@/store/userStore";
import events from "@/components/home/event";
import eventLabels from "@/components/eventDetails/label";
import ticketItems from "@/components/eventDetails/ticket";
import {aSyncData, nl2br} from "@/modules/main";
import Lounge from "@/components/eventDetails/lounge";

export default {
  name: "EventDetails",
  title: "EventDetails",
  components: {
    Lounge,
    'events': events,
    ticketItems,
  },
  setup() {
    const auth = authStore()
    const config = configStore()
    const user = userStore()

    return {auth, config, user}
  },
  data(){
    return {
      events: [],
      eventDetails: {},
      eventLabels: '',
      startTime: '',
      startDate: '',
      startDay: '',
      isAttendees: false,
      ticketItems: [],
      lounges: '',
      filterModal: false,
      cheapestPrice: '',
      vvkEnd: '',
      shareMenu: false
    }
  },
  computed: {
  },
  mounted() {
    this.config.loading = false
    this.loadDetails()
    this.getCheapestTicket()
    this.checkShareFunction()
  },
  methods: {
    checkShareFunction() {
      if (navigator.share) {
        this.shareMenu = true;
      } else {
        this.shareMenu = false;
      }
    },
    openShareMenu() {
      if (navigator.share) {
        navigator.share({
          title: this.eventDetails.title,
          url: window.location.href
        })
      }
    },
    loadDetails(){
      aSyncData('eventdetails/getDetails', {eventId: this.$route.params.id})
          .then(r => {
            console.log(r)
            if(r.status === 250){
              this.events = r.data.events
              this.eventDetails = r.data.eventDetails
              this.ticketItems = r.data.ticketItems
              this.eventLabels = r.data.eventLabels
              this.lounges = r.data.lounges
              this.isAttendees = r.data.isAttendees
              const jsTimestamp = r.data.eventDetails.startTime.split(' ')
              const jsDate = jsTimestamp[0].split('-')
              const jsTime = jsTimestamp[1].split(':')
              this.startTime = jsTime[0] + ':' + jsTime[1]
              this.startDate = jsDate[2] + '.' + jsDate[1]
              const d = new Date(r.data.eventDetails.startTime);
              switch(d.getDay()) {
                case 0:
                  this.startDay = 'Sonntag'
                  break;
                case 1:
                  this.startDay = 'Montag'
                  break;
                case 2:
                  this.startDay = 'Dienstag'
                  break;
                case 3:
                  this.startDay = 'Mittwoch'
                  break;
                case 4:
                  this.startDay = 'Donnerstag'
                  break;
                case 5:
                  this.startDay = 'Freitag'
                  break;
                case 6:
                  this.startDay = 'Samstag'
                  break;
              }

            }
          })
    },
    attendee() {
      if(!this.auth.isAuth) this.$router.push('/login?redirect=' + this.$route.path)
      const _this = this
      const fD = new FormData()
      fD.append('eventId', this.$route.params.id)
      fD.append('isAttendees', JSON.stringify(this.isAttendees))
      fD.append('sessionID', this.auth.sessionID)
      this.axios.post('eventdetails/attendee', fD)
          .then(r => {
            if(r.status === 250) _this.isAttendees = !_this.isAttendees
          })
    },
    nl2br(str){
      return nl2br(str)
    },
    scrollToTickets(){
      this.$refs['tickets'].scrollIntoView({behavior: "smooth"})

      !function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};

        ttq.load('CGCR9LRC77U734TI19L0');
        ttq.page();
      }(window, document, 'ttq');
    },
    getCheapestTicket(){
      const _this = this
      const fD = new FormData()
      fD.append('eventId', this.$route.params.id)
      fD.append('sessionID', this.auth.sessionID)
      this.axios.post('eventdetails/getCheapestTicket', fD)
          .then(r => {
            if(r.status === 250)
              _this.cheapestPrice = r.data.price
              const jsTimestamp = r.data.sellEnd.split(' ')
              const jsTime = jsTimestamp[1].split(':')
              _this.vvkEnd = jsTime[0] + ':' + jsTime[1]
          })
    }
  }
}
</script>

<style>
main{
  padding-top: 80px;
}
section#searchResults{
  padding: 16px;
  margin-top: 32px;
}
section#eventDetailsHeader{
  padding: 16px;
}
section#eventDetailsHeader .label{
  margin-right: 16px;
  margin-bottom: -32px;
  position: relative;
  z-index: 3;
  padding: 10px 8px;
  text-transform: none;
}
section#eventDetailsHeader img.titleImage{
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 2px solid #ffffff;
  margin-bottom: 10px;
  margin-top: -8px;
}
section#eventDetailsHeader h4{
  font-size: 1.6em;
  font-family: 'Helvetica';
  font-weight: 600;
  color: rgba(255,255,255,1);
  margin-bottom: 0px;
}
section#eventDetailsHeader .meta{
  padding-top: 4px;
  opacity: 0.6;
}
section#eventDetailsHeader .meta ul{
  padding: 0;
  margin: 0;
}
section#eventDetailsHeader .meta ul li{
  padding: 0;
  margin: 0;
  display: inline;
  margin-right: 12px;
  font-weight: 200;
  font-size: 0.8em;
}
section#eventDetailsHeader .meta ul li img{
vertical-align: -4px;
}

section#eventDetailsHeader .detailswrapper{
  column-gap: 12px;
  margin-bottom: 30px;
}

section#eventDetailsHeader .detailbox{
  background-color: #1E1E1E;
  padding: 16px;
  border-radius: 10px;
}

section#eventDetailsHeader .detailboxFlex{
  display: flex;
  align-items: center;
  background-color: #1E1E1E;
  padding: 4px;
  border-radius: 10px;
  margin-top: 12px;
  justify-content: center;
  text-align: left !important;
  column-gap: 4px
}

section#eventDetailsHeader .detailboxFlex p{
  font-size: 0.9em;
}

section#eventDetailsHeader .ticketButton{
  margin: 12px 0;
}

section#eventDetailsHeader .ticketButton a{
  text-transform: none;
  padding: 12px 32px;
  font-weight: 500;
  font-size: 0.8em;
  margin-right: 16px;
  vertical-align: top;
  background-color: #2068ff!important;
  color: white;
  border: none;
  border-radius: 8px;
  display: inline-block;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}

section#eventDetailsHeader .clubzettel {
  margin: 12px 0 0;
}

section#eventDetailsHeader .clubzettel .grid-12{
  column-gap: 12px;
}

section#eventDetailsHeader .clubzettel .flex{
  align-items: center;
  justify-content: center;
  column-gap: 12px;
}

section#eventDetailsHeader .clubzettel .box{
  padding: 16px;
  background-color: #1E1E1E;
  border-radius: 10px;
}



section#eventDetailsHeader h4{
  font-size: 1em;
  font-weight: 600;
}

section#eventDetailsHeader h5{
  font-size: 0.8em;
  padding-top: 6px;
  font-weight: 400;
}

section#eventDetailsContent{
  padding-top: 0;
  margin-top: -16px;
}
section#eventDetailsContent h5{
  font-size: 1.2em;
}
section#eventDetailsContent p{
  margin-top: 8px;
  font-size: 0.95em;
  font-family: 'Helvetica';
  font-weight: 300;
  color: white;
}

section#eventDetailsContent .eventDetailsBox{
  background-color: var(--second-bg-color);
  margin: 16px;
}

section#eventDetailsContent #eventLabels span{
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 16px;
  font-weight: 400;
  font-size: 0.9em;
  font-family: 'Helvetica';
  margin-right: 8px;
  display: inline-block;
  margin-bottom: 8px;
}
section#joinCTA{
  margin-bottom: 32px;
}
section#joinCTA h5{
  margin-bottom: 16px;
  font-size: 1.1em;
  font-weight: 500;
}
section#joinCTA button:not(.sharebutton){
  text-transform: none;
  padding: 12px 32px;
  font-weight: 500;
  font-size: 0.8em;
  margin-right: 16px;
  vertical-align: top;

}
section#joinCTA button.sharebutton{
  padding: 8px 10px;
}
section#ticketSale h4{
  font-size: 1.3em;
  margin-top: 16px;
  margin-bottom: 16px;
  font-weight: 500;
}
section#ticketSale button{
  text-transform: none;
}
section#ticketSale p{
  color: rgba(255,255,255,0.6);
}
section#eventHoster h5{
  font-weight: 300;
  margin-top: 32px;
  font-size: 0.8em;
  margin-bottom: 8px;
}
section#otherEvents h4{
  font-size: 1.5em;
  font-weight: 300;
  margin-top: 32px;
}
section#otherEvents h4 span{
  font-weight: 700;
}


</style>